import React from "react";
import { Form, Checkbox, Divider } from "antd";
import UserInfoFormForInvite from "./UserInfoFormForInvite";
import { connect } from "react-redux";
import history from "../../../../../history/history";
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../../utils/sessionUtil";
import { FormContainer, CheckboxWrapper, AdvisoryFormWrapper, DisplayFlexSpaceMobile, Err } from "../../../Components/Step1Setup/styles";
import { Authorizecheckbox } from "./styles"
import { DisplayFlex, CustomCheckbox,Spinner } from "../../../../../CommonComponents/commonStyles";
import { clearIipSubmit, postInvite,clearIpIsError } from "../../../../MyAccounts/actions";
import { DividerWrap } from "../../Step1Setup/Components/RelatedContributor/styles";
import { initiateTracking, recordError } from "../../../../../utils/commonUtil";
import regexMap from "../../../../../utils/regexMap";
import moment from "moment";
import { ContentMessage, Types } from "../../../../../CommonComponents/ContentMessages";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
import AlertBox from "../../../../../CommonComponents/AlertBox";
import { resetZipCode, resetAllZipFields } from "../../../../../CommonComponents/Zipcode/actions";
import PropTypes from "prop-types";
import { iipDerivedStates } from "../selectors";


const errorMessages = {

  roleReq: 'Please select role.',
  firstNameReq: 'Please enter first name.',
  firstNameLen: 'First name is too short.',
  lastNameReq: 'Please enter last name.',
  lastNameLen: 'Last name is too short.',
  genderReq: 'Please select gender.',
  dobReq: 'Please enter date of birth.',
  ssnReq: 'Please enter last four digits of SSN/PIN.',
  ssnLen: 'Social security number is too short. Please correct to continue.',
  cssnReq: 'Please re-enter last four digits of SSN/PIN.',
  ssnNoMatch: 'Social security numbers do not match. Please try again.',
  phoneTypeReq: 'Please select phone type.',
  phoneReq: 'Please enter phone number.',
  emailTypeReq: 'Please select email type.',
  emailReq: 'Please enter email address.',
  invalidEmail: 'Please enter a valid email address.',
  addrTypeReq: 'Please select address type.',
  line1Req: 'Please enter address.',
  zipcodeReq: 'Please enter zip code.',
  invalidZip: 'The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.',
  stateReq: 'Please enter state.',
  stateUsReq: 'Please select state.',
  stateLen: 'State name is too short.',
  invalidState: 'Please enter a valid state.',
  cityReq: 'Please enter city.',
  cityLen: 'City is too short.',
  countryReq: 'Please select country.'

}

class UserInviteForm extends React.Component {
  constructor(props) {
    super(props);
   this.phoneFormRef = React.createRef();
   this.emailFormRef = React.createRef();
    this.state = {
      loader: false,
      show: false,                
      isSubmit: false,
      formFields: {
        role: this.getFieldProps('', true, '', '', '', errorMessages.roleReq),
        firmName: this.getFieldProps(),
        accessLevel: this.getFieldProps('Read Only', true),
        title: this.getFieldProps(),
        firstName: this.getFieldProps('', true, 2, '', '', errorMessages.firstNameReq, errorMessages.firstNameLen, ''),
        middleName: this.getFieldProps(),
        lastName: this.getFieldProps('', true, 2, '', '', errorMessages.lastNameReq, errorMessages.lastNameLen, ''),
        suffix: this.getFieldProps(),
        gender: this.getFieldProps(),
        dob: this.getFieldProps('', true, '', '', '', errorMessages.dobReq),
        ssn: this.getFieldProps('', true, 4, '', regexMap.ssn, errorMessages.ssnReq, errorMessages.ssnLen),
        confirmSsn: this.getFieldProps('', true, 4, '', regexMap.ssn, errorMessages.ssnReq, errorMessages.ssnNoMatch),
        addressType: this.getFieldProps('', true, '', '', '', errorMessages.addrTypeReq),
        line1: this.getFieldProps('', true, '', '', '', errorMessages.line1Req),
        line2: this.getFieldProps(),
        line3: this.getFieldProps(),
        city: this.getFieldProps('', true, 2, '', regexMap.city, errorMessages.cityReq, errorMessages.cityLen),
        state: this.getFieldProps('', true, 2, '', regexMap.state, errorMessages.stateReq, errorMessages.stateLen),
        zipcode: this.getFieldProps('', true, '', regexMap.uszipCode, regexMap.zipcode, errorMessages.zipcodeReq, '', errorMessages.invalidZip),
        zipcodeNonUs: this.getFieldProps('', true, '', '', regexMap.nonUSZipCode, errorMessages.zipcodeReq),
        country: this.getFieldProps('United States', true, '', '', '', errorMessages.countryReq),
        authorized: this.getFieldProps(false, true)
      },
      phone:[],
      email:[]  
    };    
    
    this.exitPopupContent = {
      heading: "Exit",
      line1: "<p>Exiting will discard all information in the flow.</p><p>Do you want to continue?</p>",      
      continue: "continue",
      cancel: "No, take me back"      
    };
  }
  getFieldProps = (value = '', required = false, length = '', regex = '',  restrictChar = '', reqErr = '', lenErr = '', regexErr = '') => {
    return {
      value,
      required,
      msg: '',
      length,
      regex,
      restrictChar,
      errors: {
        reqErr,
        lenErr,
        regexErr            
      }
    }
  }
  
  handleExit = () => {
    this.setState({
      show: true      
    });
  };

  getCurrentEstTime() {
    let offset = -4.0;
    let isttoday = new Date();
    let utc = isttoday.getTime() + (isttoday.getTimezoneOffset() * 60000);
    let serverDate = new Date(utc + (3600000 * offset));
    let dte = serverDate.getDate();
    let dtetocase = "0", mnthtocase = "0", hrtocase = "0", mintocase = "0", sectocase = "0";
    let mnth = serverDate.getMonth() + 1;    
    let yr = serverDate.getFullYear();
    let hr = serverDate.getHours();    
    let min = serverDate.getMinutes();    
    let sec = serverDate.getSeconds();

    dtetocase = dte < 10 ? `${dtetocase}${dte}`: dte;
    mnthtocase = mnth < 10 ? `${mnthtocase}${mnth}`: mnth;
    dtetocase = mnthtocase + "/" + dtetocase + "/" + yr;
  
    if (hr < 10) {
      hrtocase = `${hrtocase}${hr}`;
    } else if (hr === 12) { 
      hrtocase = "00";
    } else { 
      hrtocase = hr;
    }

    mintocase = min < 10 ? `${mintocase}${min}`: min;
    sectocase = sec < 10 ? `${sectocase}${sec}`: sec;    
    let timetocase = hrtocase + ":" + mintocase + ":" + sectocase;
    return dtetocase + "," + timetocase;
  }

  componentDidUpdate(oldPros) {
    let { formFields } = this.state;
    if(this.props.isSuccess === true) {
      this.props.clearIipSubmit()
      history.push({
        pathname: "/my-account",
        state: {
          showSuccessMessage:true,
          messageText:"Interested Party"
        }
      });
    }
    let zipcodeReducerValue = this.props.zipCodeData;
    if (formFields.country.value === "United States" && zipcodeReducerValue && zipcodeReducerValue.zipcode1) {
      if (JSON.stringify(oldPros.zipCodeData) !== JSON.stringify(this.props.zipCodeData)) {
        let cityName;
        if(zipcodeReducerValue && zipcodeReducerValue.zipcode1 && zipcodeReducerValue.zipcode1.city) {
          cityName = zipcodeReducerValue.zipcode1.city;
        } else {
          cityName = formFields.city.value || '';
        }
        this.setData(cityName, 'city');
        let stateName;
        if(zipcodeReducerValue && zipcodeReducerValue.zipcode1 && zipcodeReducerValue.zipcode1.state) {
          stateName = zipcodeReducerValue.zipcode1.state;
        } else {
          stateName = formFields.state.value || '';
        }
        this.setData(stateName, 'state');
        if(zipcodeReducerValue && zipcodeReducerValue.zipcode1 && zipcodeReducerValue.zipcode1.zip === null
          && zipcodeReducerValue.zipcode1.city === null && zipcodeReducerValue.zipcode1.state === null
          ) {
           formFields.city.value = '';
           formFields.state.value = '';
          }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      if(nextProps.isError)
      {
        this.setState({
          isSubmit: false,
          loader: false
        });
      }
    }
   }

  getRoleType = (role,accessLevel) => {

   return  ["Professional advisor"].includes(role)?`Trusted Advisor - ${accessLevel}`:`Designated Party - ${accessLevel}`

  }

  validateForms = ()=>{
    const {validateFields:validatePhone }  = this.phoneFormRef.current.form;
    const {validateFields:validateEmail }  = this.emailFormRef.current.form;
    return Promise.all([validatePhone(),validateEmail()]).then(()=>(true)).catch(()=>(false));
  }

  submitData = async () => {
    try {
      const ESTTIME = this.getCurrentEstTime();   
      this.setState({
        isSubmit: true,
        loader: true
      });
     this.props.clearIpIsError();
     let isValidForm = await  this.validateForms();

      if (this.validateForm()&&isValidForm) {    
        const userInfo = getAccountData();
        let apiSubmitData = {
          "accountId":getPrimaryAccount().userId, "requestedBy": userInfo.partyId, "primary": false, "roleType": this.getRoleType(this.state.formFields.role.value, this.state.formFields.accessLevel.value),
          "title": this.state.formFields.title.value,
          "firstName": this.state.formFields.firstName.value,
          "middleName": this.state.formFields.middleName.value,
          "lastName": this.state.formFields.lastName.value, "Firm": this.state.formFields.firmName.value,
          "suffix": this.state.formFields.suffix.value,
          "gender": this.state.formFields.gender.value,
          "dateOfBirthStr": this.state.formFields.dob.value ? moment(this.state.formFields.dob.value).format('MM/DD/YYYY') : "",
          "ssn": this.state.formFields.ssn.value,
          "deliveryMethod": this.state.formFields.accessLevel.value === "No Access" ? "Paper" : "E-Delivery",
          "phones":this.state.phone.map((phn,index)=>{return  {
            phoneType:phn.phonetype,
            phoneNumber:phn.phonenumber
          }}),
          "emails":this.state.email.map((eml,index)=>{
            return {
              emailType:eml.emailtype,
              emailId:eml.emailId
            }
          }),
          "addresses": [
            {
              "addressType": this.state.formFields.addressType.value,
              "addressLine1": this.state.formFields.line1.value,
              "addressLine2": this.state.formFields.line2.value,
              "addressLine3": this.state.formFields.line3.value,
              "city": this.state.formFields.city.value,
              "state": this.state.formFields.state.value,
              "zipCode": this.state.formFields.country.value === 'United States' ? this.state.formFields.zipcode.value : this.state.formFields.zipcodeNonUs.value,
              "country": this.state.formFields.country.value,
              "primary": "1"
            }
          ]

        }

        const data = {
          method: "POST",
          page: "UserInviteForm",
          url: `/DP/FinancialAccountRole/AddRole`,
          data: apiSubmitData,
          isBhoomiUrl: true
        };
        this.props.submitData(data);
      }
      else{
        this.setState({
          isSubmit:false,
          loader: false
        });
      }
    } catch (error) {
      recordError(error);
    }
  };

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleExitClick = () => {
    const { cancelText, getPageTitle } = this.props;
    initiateTracking("cancel2", getPageTitle(), '', cancelText);
    this.setState({
      show: !this.state.show
    });
    window.history.back();
    window.scrollTo(0, 0);
  };

  validateForm() {
    let { formFields } = this.state; 
    let validate = true;   
    for (let key in formFields) {      
      if(key !== 'zipcode' && key !== 'zipcodeNonUs') {
        if(formFields[key].required && !formFields[key].value) {
          formFields[key].msg = formFields[key].errors.reqErr;
          validate = false;
        }else if(formFields[key].value && formFields[key].length && formFields[key].value.length < formFields[key].length) {
          formFields[key].msg = formFields[key].errors.lenErr;
          validate = false;
        } else if(formFields[key].value && formFields[key].regex && !formFields[key].regex.test(formFields[key].value)) {
          formFields[key].msg = formFields[key].errors.regexErr;
          validate = false;
        } else if(formFields[key].value && key === 'confirmSsn' && formFields.ssn.value !== formFields[key].value) {
          formFields.confirmSsn.msg = formFields.confirmSsn.errors.lenErr;
          validate = false;
        }
      } else if(formFields.country.value === 'United States' && key === 'zipcode') {        
        if(!formFields.zipcode.value) {
          formFields.zipcode.msg = formFields.zipcode.errors.reqErr;
          validate = false;
        } else if(formFields.zipcode.value && !formFields.zipcode.regex.test(formFields.zipcode.value)) {
          formFields.zipcode.msg = formFields.zipcode.errors.invalidZip;
          validate = false;
        }
      } else if(formFields.country.value !== 'United States' && key === 'zipcodeNonUs' && !formFields.zipcodeNonUs.value){
        formFields.zipcodeNonUs.msg = formFields.zipcodeNonUs.errors.reqErr;
        validate = false;
      }
    }

    this.setState({
      formFields      
    });
    return validate;
  }
  handleFormChange = (values)=>{
    this.setState({
      ...values
    })

  }

  setData(value, field, onBlur = false) { 
    let { formFields } = this.state;
    value = field === 'dob' && onBlur ? formFields.dob.value: value;

    if(formFields.hasOwnProperty(field)) {
      formFields[field].msg = '';
      if(onBlur) {
        if(formFields[field].required && !value) {
          formFields[field].msg = formFields[field].errors.reqErr;
        }else if(value && formFields[field].length && value.length < formFields[field].length) {
          formFields[field].msg = formFields[field].errors.lenErr;
        } else if(value && formFields[field].regex && !formFields[field].regex.test(value)) {
          formFields[field].msg = formFields[field].errors.regexErr;        
        }else if(value && field === 'confirmSsn' && formFields.ssn.value !== value) {
          formFields['confirmSsn'].msg = formFields['confirmSsn'].errors.lenErr;
        }
      } else if(regexMap.eliminateSpace.test(value)) {        
        if(formFields[field].restrictChar && formFields[field].restrictChar.test(value)) {              
          formFields[field].value = value;
        } else if(!formFields[field].restrictChar) {          
          formFields[field].value = value;
        }

        if(field === 'country') {
          formFields.city.value = '';
          formFields.state.value = '';
          formFields.zipcode.value = '';
          formFields.zipcodeNonUs.value = '';
        }

      } else {
        formFields[field].value = '';
      }    

      this.setState({
        formFields
      })
    } 
  }

  render() {  
    
    const { cancelText } = this.props;  

    return (
      <div data-test="userInviteFormBlock">
        <AlertBox 
          id="invitePartiespopup"
          show={this.state.show}
          name="Exit Form"
          field_page="Invite interested parties"
          primaryBtnEvent={this.handleExitClick.bind(this)}
          secondaryBtnEvent={this.closeModal.bind(this)}
          defaultContent={this.exitPopupContent}
        />
        <AdvisoryFormWrapper>
          <FormContainer hideRequiredMark>
            <Form>
              <UserInfoFormForInvite
                data-test="infoForm"
                zipCodeData={this.props.zipCodeData}
                resetZipCode={(val, field) => this.props.resetZipCode(val, field)}
                resetAllZipCode={(val) => this.props.resetAllZipCode(val)}
                formFields={this.state.formFields}
                setData={ this.setData.bind(this) }
                handleFormChange = {this.handleFormChange}
                phoneFormRef={this.phoneFormRef}
                emailFormRef={this.emailFormRef}
                phoneState={this.state.phone}
                emailState={this.state.email} 
                /> 
                          
            </Form>
            <DividerWrap>
              <Divider />
            </DividerWrap>
            <div className="fluid">
              <DisplayFlex>
                  <CustomCheckbox data-test="checkbox-block" id="chkAuthorized" aria-label="Authorize" onChange={e => this.setData(e.target.checked, 'authorized')}>
                </CustomCheckbox>
                <Authorizecheckbox>
                  <ContentMessage
                    type={[Types.SUB_HEADING_LEGACY_OPTIONS]}
                    html={true}
                    page="Invite interested parties"
                    property="field_type_10_description"
                    defaultMessage="<p>I authorize Vanguard Charitable to release information and/or provide access to the account to the interested party named above. I acknowledge I have read and agree to abide by the <a href='/company-policies/terms-and-conditions' target='_blank'>Terms & Conditions</a> in the <a href='/company-policies/policies-and-guidelines' target='_blank'>Policies & Guidelines</a>.</p>" />
                </Authorizecheckbox>
              </DisplayFlex>
            </div>
            <DividerWrap>
              <Divider />
            </DividerWrap>
            {
              !this.state.formFields.authorized.value && this.state.isSubmit
              && <Err>Please accept our Terms & Conditions.</Err>
            }
            <DisplayFlexSpaceMobile className="flex-row">
              <DisplayFlex>
                  <GeneralButton
                    id="btnCancel"
                    type="functional"
                    onClick={this.handleExit}
                    text={cancelText}
                    width="150px"
                    mobWidth="151px"
                    styling="AlignmentWrapper"
                    inverted={true}
                  ></GeneralButton>
              </DisplayFlex>
              {!this.state.loader ? (
              <GeneralButton
              id="btnSubmit"
              type="functional"
              disabled={isGeminiUser()}
              onClick={this.submitData}
              text="SUBMIT"
              width="150px"
              mobWidth="151px"
              mobMargin="0px !important"
              styling="mt1-625"
            ></GeneralButton>
            ) : (
              <GeneralButton
              id="btnSubmit2"
              type="functional"
              text={<Spinner />}
              width="150px"
              mobWidth="151px"
              mobMargin="0px !important"
              styling="mt1-625"
            ></GeneralButton>              
              )} 
            </DisplayFlexSpaceMobile>
          </FormContainer>
        </AdvisoryFormWrapper>
      </div>
    );
  }
}

UserInviteForm.propTypes = {
  title: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  getPageTitle: PropTypes.func,
  isSuccess: PropTypes.bool,
  zipCodeData: PropTypes.object,
  submitData: PropTypes.func,
  resetZipCode: PropTypes.func,
  resetAllZipCode: PropTypes.func 
}

const WrappedProfileForm = Form.create({ name: "iip" })(UserInviteForm);

const mapStateToProps = state => ({  
  ...iipDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => {
  return {  
    submitData: (data) => dispatch(postInvite(data)),
    resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
    resetAllZipCode: (val) => dispatch(resetAllZipFields(val)),
    clearIipSubmit: () => dispatch(clearIipSubmit()),
    clearIpIsError: () => dispatch(clearIpIsError())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedProfileForm);